<style lang="scss" scoped>
</style>

<template>
    <div v-if="user && (user.first_name || user.last_name)" class="avatar text-avatar mx-auto flex-none">
        <span>{{ user.first_name.charAt(0) }} {{ user.last_name.charAt(0) }}</span>
    </div>
    <div v-else class="avatar text-avatar mx-auto flex-none">
        <span>sts</span>
    </div>
</template>


<script>
export default {
    props: {
        user: {
            required: true
        }
    }
}
</script>